
        require('babel-runtime/core-js/promise').default = require('bluebird');
        require('./src/main');
        
    


//////////////////
// WEBPACK FOOTER
// ./build/loaders/app-entry.js?skipBranding=true
// module id = 2184
// module chunks = 95